const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="512"
      height="512"
      fill="none"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        fill="#000"
        d="M436.053 381.764a38.406 38.406 0 019.118 42.306A38.396 38.396 0 01409.112 448a38.408 38.408 0 01-27.348-11.947L255.307 309.619 128.849 436.053a38.402 38.402 0 01-64.846-27.349 38.403 38.403 0 0110.558-26.94l126.433-126.457L74.561 128.849a38.4 38.4 0 016.405-58.307 38.403 38.403 0 0120.943-6.539 38.403 38.403 0 0126.94 10.558l126.458 126.433L381.764 74.561a38.403 38.403 0 0164.846 27.348 38.401 38.401 0 01-10.557 26.94L309.619 255.307l126.434 126.457z"
      ></path>
    </svg>
  );
};

export default CloseIcon;
